import type { Conditions } from "../../common/types.ts";

// Icons fork: ZenGM's changelog phone-home is disabled.
//
// Upstream, this fetched https://zengm.com/changelog.php on boot and popped up
// ZenGM's latest version notes inside the game, which made it look like
// "Basketball GM" was pushing updates into our fork. We serve our own build
// from our own origin, so there is nothing to check. No-op.
export const checkChanges = async (_conditions: Conditions) => {};
